import * as Sentry from "@sentry/react";

export const stateTransformer = (state: Record<string, unknown>): Record<string, string> => {
  return Object.keys(state).reduce(
    (acc, key) => {
      acc[key] = "[Filtered]";
      return acc;
    },
    {} as Record<string, string>
  );
};

export const actionTransformer = (action: { type: string }): { type: string } => ({
  type: action.type,
});

export const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  stateTransformer,
  actionTransformer,
});
